import { Input } from 'antd';
import styled from 'styled-components/macro';

export const StyledFilterFormSearch = styled(Input.Search)`
  grid-row: 1 / 2;
  grid-column: 1 / 2;
`;
